import React, { FC } from 'react';
import cx from 'classnames';

import Wrapper from 'components/Layout/Wrapper';

import styles from './section.module.scss';

interface IProps {
  className?: string;
  id?: string;
  wrapperClassName?: string;
  isDark?: boolean;
  isFullscreen?: boolean;
  isCentered?: boolean;
}

const Section: FC<IProps> = ({
  children,
  className,
  id,
  wrapperClassName,
  isDark,
  isFullscreen,
  isCentered,
}) => (
  <section
    className={cx(
      styles.section,
      {
        [styles.sectionDark]: isDark,
        [styles.sectionFullscreen]: isFullscreen,
        [styles.sectionCentered]: isCentered,
      },
      className,
    )}
    id={id}
  >
    <Wrapper className={wrapperClassName}>
      {children}
    </Wrapper>
  </section>
);

export default Section;
